import './S_Link.scss';
import classNames from 'classnames';
import { PropsWithChildren, ReactElement } from 'react';
import { Link } from 'react-router-dom';

interface IProps {
  to: string;
  disabled?: boolean;
  title?: string;
  className?: string;
  color: 'text' | 'anchor';
}

export const S_Link2 = (props: PropsWithChildren<IProps>): ReactElement => {
  return (
    <Link
      className={classNames('s-link', props.className, props.color, { disabled: props.disabled })}
      title={props.title}
      to={props.to}
    >
      {props.children}
    </Link>
  );
};
